import { render, staticRenderFns } from "./getCurrentPosition.vue?vue&type=template&id=07124ebe&"
import script from "./getCurrentPosition.vue?vue&type=script&lang=js&"
export * from "./getCurrentPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports